import { useBusinessCentralGesecResourceShowQuery } from "../api/gesec-resource-api";
import { GesecResource } from "../types/gesec-resource";

export function BusinessCentralGesecResourceName({
  no,
  bcCompanyId,
}: {
  no: string;
  bcCompanyId: string;
}) {
  const { data } = useBusinessCentralGesecResourceShowQuery({
    no,
    companyId: bcCompanyId,
  });

  if (!data) return null;

  return resourceDisplayname(data);
}

export function resourceDisplayname(resource: GesecResource): string {
  return `${resource.no} - ${resource.name} ${resource.name2}`.trim();
}
